<template lang="pug">
.m-card
  .m-card-header(:id="'heading-cl-' + id" :data-bs-target="'#collapse-cl-' + id" :aria-controls="'collapse-cl-' + id" data-bs-toggle='collapse' role='button' aria-expanded='false')
    .group
      .league-name {{ $tc("m.BT_CL", 1) }}
  .m-card-body.collapse.show(:id="'collapse-cl-' + id" :aria-labelledby="'heading-cl-' + id" aria-expanded='false')
    .m-card-item(:class="{ 'live' : marketType == 3 }")
      .m-card-wrap
        .odds-wrapper(v-if="mode == 0 || mode == 1")
          .m-label-wrap
            .m-label F.T
          .odds-group
            .col
              template(v-if="moreItems['clo']['HY'] && moreItems['clo']['HY'][5] != 0 && moreItems['clo']['HY'][5] != ''")
                OddsItem(:odds="moreItems['clo']['HY']" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BT_HY')")
              template(v-else)
                OddsDisabled
              template(v-if="moreItems['clo']['HN'] && moreItems['clo']['HN'][5] != 0 && moreItems['clo']['HN'][5] != ''")
                OddsItem(:odds="moreItems['clo']['HN']" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BT_HN')")
              template(v-else)
                OddsDisabled
            .col
              template(v-if="moreItems['clo']['AY'] && moreItems['clo']['AY'][5] != 0 && moreItems['clo']['AY'][5] != ''")
                OddsItem(:odds="moreItems['clo']['AY']" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BT_AY')")
              template(v-else)
                OddsDisabled
              template(v-if="moreItems['clo']['AN'] && moreItems['clo']['AN'][5] != 0 && moreItems['clo']['AN'][5] != ''")
                OddsItem(:odds="moreItems['clo']['AN']" idx=5 :typ="oddsType" dataType="3" :label="$t('m.BT_AN')")
              template(v-else)
                OddsDisabled




//- .card.market-card
//-   .card-header.bg-more-head.collapse-more(
//-     :id="'heading-cl-' + id"
//-     data-toggle='collapse'
//-     :data-target="'#collapse-cl-' + id"
//-     :aria-controls="'collapse-cl-' + id"
//-     aria-expanded=true
//-   )
//-     .flex-grow-1.text-ellipsis.text-uppercase.mr-2 {{ $tc("m.BT_CL", 1) }}
//-   .collapse.show(
//-     :aria-labelledby="'heading-cl-' + id"
//-     :id="'collapse-cl-' + id"
//-   )
//-     .card-body.p-0
//-       .market-card-content
//-         .normal(v-if="mode == 0 || mode == 1")
//-           .normal-title {{ $t("ui.full_time") }}
//-           .normal-odd-area
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_HY") }}
//-               template(v-if="moreItems['clo']['HY'] && moreItems['clo']['HY'][5] != 0 && moreItems['clo']['HY'][5] != ''")
//-                 OddsItem(:odds="moreItems['clo']['HY']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_HN") }}
//-               template(v-if="moreItems['clo']['HN'] && moreItems['clo']['HN'][5] != 0 && moreItems['clo']['HN'][5] != ''")
//-                 OddsItem(:odds="moreItems['clo']['HN']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_AY") }}
//-               template(v-if="moreItems['clo']['AY'] && moreItems['clo']['AY'][5] != 0 && moreItems['clo']['AY'][5] != ''")
//-                 OddsItem(:odds="moreItems['clo']['AY']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
//-             .normal-odd-area-group
//-               .normal-odd-area-oddtype.text-center.mr-0 {{ $t("m.BT_AN") }}
//-               template(v-if="moreItems['clo']['AN'] && moreItems['clo']['AN'][5] != 0 && moreItems['clo']['AN'][5] != ''")
//-                 OddsItem(:odds="moreItems['clo']['AN']" idx=5 :typ="oddsType" dataType="3" :details="moreItems")
//-               template(v-else)
//-                 OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";
import mixinHDPOUOdds from "@/library/mixinHDPOUOdds";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  mixins: [mixinHDPOUOdds],
  props: {
    mode: {
      type: Number
    }
  }
}
</script>
